export const COMPONENT_NAME = 'Settings.Subscriptions';
